import React from 'react';
import PropTypes from 'prop-types';

function Schedule({ children, className }) {
  return (
    <section className={className}>{children}</section>
  );
}

export default React.memo(Schedule);
